<script setup>
</script>

<template>
  <footer>
    <div class="container">
      <NuxtImg src="/images/psLogo.png" alt="partners_logo" width="116" height="25" format="webp" loading="lazy" />
      <div>
        <p>
          브릿지코드 주식회사 <br />
          사업자번호 : 781-81-01811 | 대표자명 : 박상민 | 주소 : 서울특별시 용산구 한강대로 23길 25 로카우스 3층 <br />
          통신판매신고업 : 2021-서울영등포-0924
        </p>
      </div>
      <p>&copy; All right reserved by BridgeCode. </p>
    </div>
  </footer>
</template>

<style scoped lang="scss">
footer {
  height: 288px;

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: #000;
  color: #fff;
}

footer img {
  filter: invert(100%);
}

footer .container {
  width: 960px;
  height: 168px;
  text-align: start;
}

footer .container > div {
  font-size: 14px;
  line-height: 1.5;
  & > p {
    margin: 30px 0;
  }
}

footer .container > p {
  font-size: 13px;
  margin: 0;
}

@media (max-width: 960px) {
  footer {
    height: 322px;
  }

  footer .container {
    width: 100%;
    height: 210px;
    padding: 0 24px;
    text-align: start;
  }
}
</style>